import {uniqueID} from '../../../../common/utils/GeneralUtils';
import {DocsState} from '../types/reducers';
import {
    AttachmentFileState, AttachmentVersion,
    DocumentTypes,
    FileState, LoanApplicationAttachmentsState,
    LoanGroupedAttachmentsState,
    UploadDateState,
    VersionState
} from '../types/types';

function previewFileUrl(file) {
    return (URL || webkitURL).createObjectURL(file);
}

export const mapFile = (file, ownerName): FileState => ({
    ownerName,
    id: uniqueID(),
    name: file.name,
    url: previewFileUrl(file),
    mimeType: file.type,
    isUploaded: false,
    size: file.size,
    lastModified: file.lastModified,
    content: file
});

export const mapUploadFile = (file: AttachmentFileState): FileState => ({
    id: file.id,
    ownerName: file.uploadUser,
    name: file.fileName,
    url: file.originalUrl,
    mimeType: file.mimeType,
    isUploaded: true,
    size: file.size,
    lastModified: file.uploadDate.value,
    lastModifiedToDisplay: file.uploadDate.displayValue,
    content: null,
    selected: file.selected
});

export const mapVersionFile = (version: AttachmentVersion, index: number): VersionState => ({
    name: version.name,
    versionId: version.versionId,
    openTree: index === 0 ? true : version.openTree,
    documentGroups: version.documentGroups.map(fileVersion => ({
        id: fileVersion.id,
        size: fileVersion.size,
        name: fileVersion.fileName,
        mimeType: fileVersion.mimeType,
        url: fileVersion.originalUrl,
        urlCompress: fileVersion.thumbnailUrl,
        details: fileVersion.fileDetail,
        uploadDate: {
            displayValue: fileVersion.uploadDate.displayValue,
            value: fileVersion.uploadDate.value
        } as UploadDateState,
        ownerName: fileVersion.uploadUser
    }))
});

export const findDocumentsByGroup = (documentState: DocsState, documentType: DocumentTypes):
    LoanApplicationAttachmentsState => {
    const docs: DocsState = documentState;
    const emptyDocumentType: DocumentTypes = {id: '', label: '', autogenerated: true, info: '', classificationId: ''};
    const emptyLoanAttachments: LoanApplicationAttachmentsState = {
        versionId: '', versionName: '', label: '', info: '', id: '',
        autogenerated: false, documentGroups: [], versions: [], classificationId: ''
    };

    const groupedAttachments: LoanGroupedAttachmentsState[] = docs.groupAttachments;
    const documentTypeSelected: DocumentTypes = documentType || emptyDocumentType;
    const classification: LoanGroupedAttachmentsState = groupedAttachments.filter(item =>
            !!item.documentGroups.filter(item => item.id === documentTypeSelected.id).pop()).pop()
        || {classificationId: '', classification: '', documentGroups: []};

    return classification.documentGroups
            .filter(item => item.id === documentTypeSelected.id).pop()
        || emptyLoanAttachments;
};